import type { FC } from 'react'
import React, { useState, useCallback, useMemo } from 'react'
import { createContext } from 'use-context-selector'

import type { ModalOptions } from '../../components/MovementsModal'

type ContextType = {
  isOpen: boolean
  open: (options: ModalOptions) => void
  close: () => void
  options: ModalOptions
}

export const MovementsModalContext = createContext({} as ContextType)

export const MovementsModalProvider: FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const [options, setOptions] = useState<ModalOptions>({} as ModalOptions)

  const open = useCallback((modalOptions: ModalOptions) => {
    setIsOpen(true)
    setOptions(modalOptions)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const contextValue = useMemo(
    () => ({
      isOpen,
      open,
      close,
      options,
    }),
    [isOpen, open, close, options]
  )

  return (
    <MovementsModalContext.Provider value={contextValue}>
      {children}
    </MovementsModalContext.Provider>
  )
}
